export class Graph {
    private edgesParentToChild: {[key: string]: string[]};
    private edgesChildToParent: {[key: string]: string[]};
    private nodes: {[key: string]: any};

    constructor() {
        this.edgesParentToChild = {};
        this.edgesChildToParent = {};
        this.nodes = {};
    }

    public addNode(nodeId: string, node: any) {
        this.nodes[nodeId] = node;
        this.edgesParentToChild[nodeId] = [];
        this.edgesChildToParent[nodeId] = [];
    }

    public addEdge(nodeId: string, childId: string) {
        this.edgesParentToChild[nodeId].push(childId);
        this.edgesChildToParent[childId].push(nodeId)
    }

    public deleteNode = (nodeId: string) => {
        delete this.nodes[nodeId];

        this.edgesParentToChild[nodeId].forEach((childId: string) => this.deleteEdge(nodeId, childId));
        this.edgesChildToParent[nodeId].forEach((parentId: string) => this.deleteEdge(parentId, nodeId));

        delete this.edgesParentToChild[nodeId];
        delete this.edgesChildToParent[nodeId];
    }

    public deleteEdge = (parentId: string, childId: string) => {
        this.edgesParentToChild[parentId] = this.edgesParentToChild[parentId].filter((id: string) => id != childId);
        this.edgesChildToParent[childId] = this.edgesParentToChild[childId].filter((id: string) => id != parentId);
    }

    public getNodes() {
        return this.nodes;
    }

    public getNode(nodeId: string) {
        return this.nodes[nodeId]
    }

    public getChildrenIds(nodeId: string) {
        return this.edgesParentToChild[nodeId];
    }

    public getParentIds(nodeId: string) {
        return this.edgesChildToParent[nodeId];
    }

    public getParents(nodeId: string) {
        return this.getParentIds(nodeId).map((parentId: string) => this.nodes[parentId]);
    }

    public getChildren(nodeId: string) {
        return this.getChildrenIds(nodeId).map((childId: string) => this.nodes[childId]);
    }

    public hasParents(nodeId: string) {
        const parentIds = this.getParentIds(nodeId);
        return parentIds && parentIds.length > 0;
    }

    public hasChildren(nodeId: string) {
        const childrenIds = this.getChildrenIds(nodeId);
        return childrenIds && childrenIds.length > 0;
    }
}